import { render, staticRenderFns } from "./MuslimLibrary.vue?vue&type=template&id=534e252d&scoped=true&"
import script from "./MuslimLibrary.vue?vue&type=script&lang=js&"
export * from "./MuslimLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e252d",
  null
  
)

export default component.exports